import { BaseButton, type BaseButtonProps } from '@/components/common/base-button';
import ShopArrowLeftIcon from '@/components/icons/shop/ArrowLeftIcon';
import ShopArrowRightIcon from '@/components/icons/shop/ArrowRightIcon';
import { useConfigStore } from '@/stores';
import clsx from 'clsx';
import { useMemo } from 'react';
import styles from './styles.module.scss';
import { getSize } from '@/utils/size';
import useBaseSize from '@/hooks/useBaseSize';

type ShopFnbFacilitySlideNavigationButtonProps = BaseButtonProps & {
    ref?: React.RefObject<HTMLButtonElement> | null;
    navigationDirection: 'next' | 'previous';
    isDisabled: boolean;
};

const ShopFnbFacilitySlideNavigationButton = ({ ref, navigationDirection, isDisabled, ...props }: ShopFnbFacilitySlideNavigationButtonProps) => {
    const constrast = useConfigStore((state) => state.config.ui.contrast);
    const { baseWidth, baseHeight } = useBaseSize();
    const buttonClasses = useMemo(() => {
        return clsx(styles['navigation-button'], {
            [styles['navigation-button--disabled']]: isDisabled,
            [styles['navigation-button--next']]: navigationDirection === 'next',
            [styles['navigation-button--previous']]: navigationDirection === 'previous',
            [styles['navigation-button--contrast']]: constrast,
            ...(props.className ? { [props.className]: true } : {}),
        });
    }, [isDisabled, constrast, navigationDirection, props.className]);

    return (
        <BaseButton {...props} ref={ref} className={buttonClasses} role="button">
            {navigationDirection === 'next' ? (
                <ShopArrowRightIcon width={getSize(16, baseWidth)} height={getSize(26, baseHeight)} />
            ) : (
                <ShopArrowLeftIcon width={getSize(16, baseWidth)} height={getSize(26, baseHeight)} />
            )}
        </BaseButton>
    );
};

export default ShopFnbFacilitySlideNavigationButton;
